import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {WeekInvoices} from '../invoice-week-selector/invoice-week-table/invoice-week-table.component';
import {InvoicesService} from '../services/invoices.service';
import {Observable} from 'rxjs/Observable';
import {InvoiceFilter} from '../../models/invoice-filter';
import * as moment from 'moment';


@Injectable()

export class InvoicesCountResolver implements Resolve<WeekInvoices[]>
{
  /**
   * InvoicesResolver constructor
   *
   * @param {InvoicesService} invoicesService
   */
  constructor(private invoicesService: InvoicesService)
  {
  }

  /**
   * Provides data to a route
   *
   * @returns {Observable<Invoice[]>}
   */
  resolve(): Observable<WeekInvoices[]>
  {
    return this.invoicesService.getInvoicesCounts(moment().year());
  }
}



// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/invoices-count.resolver.ts